import "bootstrap/dist/css/bootstrap.min.css";
import React, { Component } from "react";
import styled from "styled-components";
import { Container, Row, Col, media } from "styled-bootstrap-grid";
import YouTube from "react-youtube";
import "./yt.css";
import { Helmet } from "react-helmet";
import theme from "ui/styles/theme";

export default class YoutubeVideo extends Component {
  constructor(props) {
    super(props);
    this.state = {
      schema: [],
    };
  }

  componentDidMount = () => {
    //Fetch metadata from youtube url to fill in the video schema
    this.getVideoData();
  };

  getVideoData = async () => {
    //Get video data from YouTube API and push to an array
    let API_KEY = "AIzaSyABGgwVhM98C4_ZQ-W28sYQiAHaDOUw8Nw";
    let schemaArray = [];
    for (let i = 0; i < this.props.videos.length; i++) {
      const videoID = this.props.videos[i].id;
      const requestUrl = await fetch(
        `https://www.googleapis.com/youtube/v3/videos?part=snippet,statistics&id=${videoID}&key=${API_KEY}`
      );
      const data = await requestUrl.json(requestUrl);
      schemaArray.push(data);
    }
    //Update state with a received data. Schema is filled based on that data
    this.setState({ schema: schemaArray });
  };

  render() {
    const { videos, bgcolor } = this.props;

    const { schema } = this.state;

    const opts = {
      width: "",
      height: "",
      playerVars: {
        autoplay: 0,
        fs: 1,
      },
    };

    const onReady = (event) => {
      const iframe = event.target.getIframe();
      iframe.setAttribute("allowFullScreen", "");
      iframe.setAttribute(
        "allow",
        "accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; fullscreen"
      );
    };

    return (
      <Wrapper bgcolor={bgcolor}>
        <Helmet>
          <script type="application/ld+json">
            {`{
                              "@context": "http://schema.org",
                              "video":
                              [
                                ${schema.map(
                                  (video, index) =>
                                    `{
                                        "@type": "VideoObject",
                                        "name": "${
                                          video.items[0].snippet.title
                                        }",
                                        "description": "${video.items[0].snippet.description.toString()}",
                                        "thumbnailUrl": "${
                                          video.items[0].snippet.thumbnails
                                            .default.url
                                        }",
                                        "embedUrl": "https://www.youtube.com/embed/${
                                          video.items[0].id
                                        }",
                                        "uploadDate":"${
                                          video.items[0].snippet.publishedAt
                                        }"
                                    }`
                                )}
                              ]
                        }`}
          </script>
        </Helmet>
        <StyledContainer fluid>
          <Row>
            {videos.map((video, index) => (
              <StyledColumn
                sm={12}
                lg={videos.length == 2 ? 6 : videos.length == 3 ? 4 : 12}
                key={index}
              >
                <Video opts={opts} videoId={video.id} onReady={onReady} />
              </StyledColumn>
            ))}
          </Row>
        </StyledContainer>
      </Wrapper>
    );
  }
}

//Styles
const Wrapper = styled.section`
  width: 100%;
  background-color: ${(props) =>
    props.bgcolor === "white" ? "white" : theme.colors.tones.lightest};
`;

const StyledContainer = styled(Container)`
  padding: 0 20px;
  ${media.lg`
                    padding: 0 20%;
                    `}
`;

const StyledColumn = styled(Col)`
  padding-top: 10px;
  padding-bottom: 10px;
  div {
    display: flex;
    justify-content: space-evenly;
    left: 0;
    width: 100%;
    height: 100%;
    border: 0;
    top: 0;
  }

  iframe {
    aspect-ratio: 16/9;
    width: 100%;
    max-width: 640px;
  }
  ${media.md`
    padding-top: 50px;
    padding-bottom: 50px;
`}
`;
const Video = styled(YouTube)``;



// WEBPACK FOOTER //
// ./src/ui/components/modules/YoutubeVideo/index.js